/* eslint-disable max-len */
import React from 'react';

export const SVGIconArrowRightThin = (
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="10.5"
      viewBox="0 0 6 10.5"
    >
      <g
        id="Group_12802"
        data-name="Group 12802"
        transform="translate(-11 19.5) rotate(-90)"
      >
        <g id="Group_6877" data-name="Group 6877" transform="translate(4 4)">
          <path
            id="chevron-down-solid"
            className="SVGIcon_colorFill"
            d="M5.25,6a.747.747,0,0,1-.53-.22L.22,1.28A.75.75,0,0,1,1.28.22L5.25,4.191,9.22.22a.75.75,0,1,1,1.061,1.061l-4.5,4.5A.748.748,0,0,1,5.25,6Z"
            transform="translate(5 7)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};
